import { render, staticRenderFns } from "./BranchVN.vue?vue&type=template&id=74d11ae7&scoped=true&"
import script from "./BranchVN.vue?vue&type=script&lang=js&"
export * from "./BranchVN.vue?vue&type=script&lang=js&"
import style0 from "./BranchVN.vue?vue&type=style&index=0&id=74d11ae7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d11ae7",
  null
  
)

export default component.exports